import { Spinner } from '@vestigas/ui/molecules';

export const LoadingPage = () => (
  <div className="flex size-full min-h-[inherit] items-center justify-center">
    <Spinner />
  </div>
);
